import { render, staticRenderFns } from "./buyCompDC.vue?vue&type=template&id=98637d32&scoped=true"
import script from "./buyCompDC.vue?vue&type=script&lang=js"
export * from "./buyCompDC.vue?vue&type=script&lang=js"
import style0 from "./buyCompDC.vue?vue&type=style&index=0&id=98637d32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98637d32",
  null
  
)

export default component.exports